import { Button, Divider, IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { removeProjectContributor } from '../../../actions/projectActions'

interface Props {
  setShowContributorModal: (val: boolean) => void
}

const Contributors = ({ setShowContributorModal }: Props) => {
  const dispatch = useDispatch()
  const { project } = useSelector(
    (state: RootStateOrAny) => state.projectDetails
  )

  const handleRemoveClick = (id: string) => {
    dispatch(removeProjectContributor(id))
  }

  return (
    <>
      <h4 className="m-b-44">Project Contributors</h4>

      <div className="contributor">
        <div className="name">{project.userName}</div>
        <div className="role">Project owner</div>
      </div>

      <Divider />

      {project.assignee && (
        <>
          <div className="contributor">
            <div className="name">{project.assigneeName}</div>
            <div className="role">Assignee</div>
          </div>
          <Divider />
        </>
      )}

      {project.contributorData &&
        project.contributorData.map((x: User) => (
          <div key={x._id}>
            <div className="contributor">
              <div className="name">
                {x.firstName} {x.lastName}
              </div>
              <div className="role">
                {x.status === 'Invited' ? (
                  <em>Invitation sent</em>
                ) : (
                  <div className="m-r-16">Contributor</div>
                )}

                <IconButton onClick={() => handleRemoveClick(x._id)}>
                  <Close style={{ color: 'gray', width: 16, height: 16 }} />
                </IconButton>
              </div>
            </div>
            <Divider />
          </div>
        ))}

      <div className="flex flex-end m-t-80">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setShowContributorModal(false)}
        >
          Done
        </Button>
      </div>
    </>
  )
}

export default Contributors
